export const MESSAGE_TYPES = {
    TEXT: 'text',
    IMAGE: 'image',
    TABLE: 'table',
    CHART: 'chart',
    DOCUMENT: 'document',
} as const;

export const MESSAGE_ROLES = {
    SYSTEM: 'system',
    ASSISTANT: 'assistant',
    USER: 'user',
} as const;

export const SPECIAL_MESSAGE_IDS = {
    STREAMING: 'streaming-message',
    SKELETON: 'temp-status-update',
} as const;

export const DEFAULT_VALUES = {
    EMPTY_THREAD_ID: '',
    EMPTY_SYMBOL: '',
    EMPTY_DESCRIPTION: '',
    UNKNOWN_VERSION: 'unknown',
    DEFAULT_NUMBER: 0,
} as const;
